import React from 'react';
import { CompassIcon, DoorOpenIcon, RocketIcon, WrenchIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { benefits } from '../data/content';
const ICONS = {
  compass: CompassIcon,
  wrench: WrenchIcon,
  door: DoorOpenIcon,
  rocket: RocketIcon
};
export function BenefitsSection() {
  return <section aria-labelledby="beneficios" className="border-b border-line bg-canvas" data-id="element-16" data-mp="3no9l6pqngzob">
      <div className="mx-auto max-w-2xl px-3 py-6 text-center sm:px-5" data-id="element-17" data-mp="38r9198epa90e">
        <h2 id="beneficios" className="font-display text-base font-extrabold leading-tight text-ink sm:text-xl" data-id="element-18" data-mp="3drn0c0ybq8ma">
          ¿Qué puede cambiar cuando empiezas?
        </h2>
        <p className="mx-auto mt-1 max-w-xl text-[0.8rem] leading-snug text-ink-muted" data-id="element-19" data-mp="34pxagzk3bhqm">
          Una habilidad técnica puede abrir nuevas posibilidades.
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-20" data-mp="xy4uxqp86gga">
          {benefits.map((benefit, i) => {
          const Icon = ICONS[benefit.icon];
          return <Reveal key={benefit.title} as="li" delay={i * 0.03} className="flex h-full gap-2.5 rounded-lg border border-line bg-surface p-3 text-left" data-id="element-21" data-mp="2bdmhd75z7n3o" data-mpi={i}>
                <span className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-md bg-cyan-soft" data-id="element-22" data-mp="2g5w288s8hwz3">
                  <Icon size={15} className="text-cyan" data-id="element-23" data-mp="1sg1ug5mruylp" />
                </span>
                <div data-id="element-24" data-mp="1oepxtg5hdd40">
                  <h3 className="font-display text-[0.8rem] font-extrabold uppercase leading-tight text-ink" data-id="element-25" data-mp="1of81gxuh2tly">
                    {benefit.title}
                  </h3>
                  <p className="mt-1 text-[0.78rem] leading-snug text-ink-muted" data-id="element-26" data-mp="22c4t31if0f3w">
                    {benefit.desc}
                  </p>
                </div>
              </Reveal>;
        })}
        </ul>
      </div>
    </section>;
}